// extracted by mini-css-extract-plugin
module.exports = {"PhotoCropInput":"bfr_a","ReactCrop--disabled":"bfr_b","ReactCrop--circular-crop":"bfr_c"};